import { render } from "./banner.vue?vue&type=template&id=3520ee78&ts=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"

import "./banner.vue?vue&type=style&index=0&id=3520ee78&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__